<div *ngFor="let alert of alerts" class="{{cssClass(alert)}} alert-block">
  <span [innerHTML]="alert.message"></span>
</div>